import React, { Component } from 'react';
import classNames from 'classnames';
import AnchorContext from './AnchorContext';
export default class AnchorLink extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = (e) => {
            const { c7nAnchor } = this.context;
            if (c7nAnchor) {
                const { scrollTo, onClick } = c7nAnchor;
                const { href, title } = this.props;
                if (onClick) {
                    onClick(e, { title, href });
                }
                scrollTo(href);
            }
        };
    }
    static get contextType() {
        return AnchorContext;
    }
    componentDidMount() {
        const { c7nAnchor } = this.context;
        if (c7nAnchor) {
            const { href } = this.props;
            c7nAnchor.registerLink(href);
        }
    }
    componentDidUpdate({ href: prevHref }) {
        const { href } = this.props;
        if (prevHref !== href) {
            const { c7nAnchor } = this.context;
            if (c7nAnchor) {
                c7nAnchor.unregisterLink(prevHref);
                c7nAnchor.registerLink(href);
            }
        }
    }
    componentWillUnmount() {
        const { c7nAnchor } = this.context;
        const { href } = this.props;
        if (c7nAnchor) {
            c7nAnchor.unregisterLink(href);
        }
    }
    render() {
        const { c7nAnchor, getPrefixCls } = this.context;
        const { prefixCls: customizePrefixCls, href, title, children, className } = this.props;
        const prefixCls = getPrefixCls('anchor', customizePrefixCls);
        const active = c7nAnchor && c7nAnchor.activeLink === href;
        const wrapperClassName = classNames(className, `${prefixCls}-link`, {
            [`${prefixCls}-link-active`]: active,
        });
        const titleClassName = classNames(`${prefixCls}-link-title`, {
            [`${prefixCls}-link-title-active`]: active,
        });
        return (React.createElement("div", { className: wrapperClassName },
            React.createElement("a", { className: titleClassName, href: href, title: typeof title === 'string' ? title : '', onClick: this.handleClick }, title),
            children));
    }
}
AnchorLink.displayName = 'AnchorLink';
AnchorLink.defaultProps = {
    href: '#',
};
